<template>
  <div>
    <v-btn left color="accent" @click.stop="dialog = !dialog"> <v-icon>add</v-icon>add </v-btn>
    <v-dialog scrollable v-model="dialog" width="800px">
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title black--text">Add Meta</v-card-title>
        <v-card-text>
          <v-form v-model="Form.valid">
            <v-container grid-list-xs :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : ''">
              <v-layout wrap>
                <v-flex xs12 md5>
                  <v-text-field
                    type="number"
                    label="Total usage limit"
                    v-validate="'numberWithInfinity|required'"
                    :error-messages="errors.collect('total_usage_limit')"
                    data-vv-name="total_usage_limit"
                    v-model="Form.total_usage_limit"
                    hint="** -1 is Unlimited **"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6 offset-md1>
                  <v-text-field
                    type="number"
                    label="Individual usage limit"
                    v-validate="'numberWithInfinity|required'"
                    :error-messages="errors.collect('individual_usage_limit')"
                    data-vv-name="individual_usage_limit"
                    v-model="Form.individual_usage_limit"
                    hint="** -1 is Unlimited **"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md5>
                  <v-text-field type="text" label="Terms link url" v-model="Form.terms_link_url"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group label="Discount Type" mandatory v-model="Form.discount_unit" row>
                    <v-radio label="Percentage" value="percentage"></v-radio>
                    <v-radio label="Amount" value="amount"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 md5>
                  <v-text-field
                    type="number"
                    label="Discount Amount"
                    v-validate="discountValidation"
                    :error-messages="errors.collect('discount_amount')"
                    data-vv-name="discount_amount"
                    v-model="Form.discount_amount"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6 offset-md1>
                  <v-text-field
                    type="number"
                    label="Discount Limit"
                    v-validate="'min_value:1|required'"
                    :error-messages="errors.collect('discount_limit')"
                    data-vv-name="discount_limit"
                    v-model="Form.discount_limit"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md5>
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        v-model="Form.promotion_start_at"
                        label="Promotaion start at"
                        prepend-inner-icon="access_time"
                        readonly
                        class="mb-1"
                      ></v-text-field>
                    </template>
                    <VueCtkDateTimePicker
                      label="promotion start at"
                      v-model="Form.promotion_start_at"
                      locale="en"
                      time-format="HH:MM"
                      format="DD-MM-YYYY HH:mm:ss"
                      inline
                      no-keyboard
                      no-button-now
                    />
                  </v-menu>
                </v-flex>
                <v-flex xs12 md6 offset-md1>
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        v-model="Form.promotion_end_at"
                        label="Promotaion end at"
                        prepend-inner-icon="access_time"
                        readonly
                        class="mb-1"
                      ></v-text-field>
                    </template>
                    <VueCtkDateTimePicker
                      label="promotion end at"
                      v-model="Form.promotion_end_at"
                      locale="en"
                      time-format="HH:MM"
                      format="DD-MM-YYYY HH:mm:ss"
                      inline
                      no-button-now
                      no-keyboard
                    />
                  </v-menu>
                </v-flex>
                <v-flex xs12 md5>
                  <v-overflow-btn
                    editable
                    class="my-2"
                    :items="currencies"
                    label="currency"
                    v-model="Form.currency"
                    target="#dropdown-example"
                  ></v-overflow-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-3 pr-5">
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">Cancel</v-btn>
          <v-btn color="primary" :disabled="!Form.valid" @click="createMeta">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style></style>

<script>
import Forms from '../form/form';
import formMixin from '../Mixins/form';
import countryMixin from '../Mixins/country';
import currencies from '../utils/currencies';

export default {
  mixins: [formMixin, countryMixin],
  props: {
    title: String,
    FormDefault: Object,
  },
  data() {
    return {
      dialog: false,
      currencies,
      Form: new Forms({
        data: () => ({
          total_usage_limit: this.FormDefault.total_usage_limit,
          individual_usage_limit: this.FormDefault.individual_usage_limit,
          discount_amount: this.FormDefault.discount_amount,
          discount_limit: this.FormDefault.discount_limit,
          discount_unit: this.FormDefault.discount_unit,
          terms_link_url: this.FormDefault.terms_link_url,
          promotion_start_at: this.FormDefault.promotion_start_at,
          promotion_end_at: this.FormDefault.promotion_end_at,
          currency: 'thb',
        }),
      }),
    };
  },
  computed: {
    discountValidation() {
      let validateRule = {
        numeric: true,
        required: true,
      };
      if (this.Form.discount_unit === 'percentage') {
        validateRule.max_value = 100;
      }
      return validateRule;
    },
  },
  watch: {
    FormDefault: {
      handler(val) {
        this.Form.$data.total_usage_limit = val.total_usage_limit;
        this.Form.$data.individual_usage_limit = val.individual_usage_limit;
        this.Form.$data.discount_amount = val.discount_amount;
        this.Form.$data.discount_limit = val.discount_limit;
        this.Form.$data.discount_unit = val.discount_unit;
        this.Form.$data.terms_link_url = val.terms_link_url;
        this.Form.$data.promotion_start_at = val.promotion_start_at;
        this.Form.$data.promotion_end_at = val.promotion_end_at;
      },
      deep: true,
    },
  },
  methods: {
    createMeta() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('clicked', this.Form.$data);
          this.closeDialog();
        }
      });
    },
    closeDialog() {
      this.dialog = false;
      this.resetFormError(null, this.Form);
    },
  },
  mounted() {},
  components: {},
};
</script>
